<mat-card class="mat-card--widget">
  <mat-card-content>
    <div class="container" *ngIf="brands$ | async">
      <!--       <mat-form-field>
        <input matInput (keyup)="search$.next($event)" placeholder="Search for a frame" />
        <mat-hint>Enter any style, color, size, upc, or search on any criteria</mat-hint>
      </mat-form-field> -->
      <div class="brand__button">
        <!-- Filter display by Brand -->
        <button
          style="margin: 2px;"
          class="btn"
          [ngClass]="[selectedBrand == 'All Brands' ? 'btn-primary' : 'btn-tertiary']"
          (click)="onSelect('All Brands')"
          name="All Brands"
        >
          All Brands
        </button>
        <ng-container *ngFor="let item of brands$ | async">
          <button
            style="margin: 2px;"
            class="btn"
            [name]="item.brandName"
            (click)="onSelect(item.brandName)"
            [ngClass]="[selectedBrand == item.brandName ? 'btn-primary' : 'btn-tertiary']"
          >
            {{ item.brandName }}
          </button>
        </ng-container>
      </div>
    </div>
  </mat-card-content>
</mat-card>
